<template>
  <div class="app-container">
    <el-row :gutter="20">
      <el-col :span="24" :xs="24">
        <el-form :model="queryParams" ref="queryParams" size="small" v-show="showSearch" label-width="100px">
          <el-row :gutter="24" type="flex" justify="right">
            <el-col :span="6">
              <el-form-item label="客户名称" prop="compNames">
                <el-input v-model="queryParams.compNames" placeholder="请输入客户名称" clearable @keyup.enter.native="handleQuery" />
                <CustomerDetails v-model="queryParams.compNames" />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="使用单位" prop="useUntName">
                <el-input v-model="queryParams.useUntName" placeholder="请输入使用单位" clearable @keyup.enter.native="handleQuery" />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="识别码" prop="oidNo">
                <el-input v-model="queryParams.oidNo" placeholder="请输入电梯识别码" clearable @keyup.enter.native="handleQuery" />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="检测日期" prop="testDateRange">
                <el-date-picker v-model="queryParams.testDateRange" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd" style="width: 100%"
                                @change="handleQuery" />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="24" type="flex" justify="right">
            <el-col :span="6">
              <el-form-item label="状态" prop="enabledState">
                <el-select v-model="queryParams.enabledState" placeholder="请选择状态" style="width: 100%" @change="handleQuery">
                  <el-option label="未录入" value="9" />
                  <el-option label="全部" value="-1" />
                  <el-option label="已录入" value="0" />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="小区名称" prop="houseName">
                <el-input v-model="queryParams.houseName" placeholder="请输入小区名称" clearable @keyup.enter.native="handleQuery" />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="到检年月" prop="inspectionMonthList">
                <el-date-picker v-model="queryParams.inspectionMonthList" type="months" placeholder="请选择到检年月" clearable value-format="yyyy-MM" style="width: 100%;" @change="handleQuery" />
              </el-form-item>
            </el-col>
          </el-row>

          <div style="text-align: center; margin-bottom: 10px">
            <PermissionMethodToolbar :url="url" :id="'toolbar'" @handleSearch="handleQuery" @handleSave="handleBatchSave" @exportToExcel="exportToExcel" @handleDelete="handleDelete" />
          </div>

          <el-table id="table" v-loading="loading" :data="tableData" border style="width: 100%; margin-top: 20px" :header-cell-style="{ background: '#d8e8fb', textAlign: 'left', borderColor: '#CCC' }"
                    @selection-change="handleSelectionChange" height="500">
            <el-table-column type="selection" width="55" align="left"></el-table-column>
            <el-table-column label="序号" type="index" align="left"  width="50" show-overflow-tooltip></el-table-column>
            <el-table-column label="识别码" align="left" prop="oidNo" min-width="120" show-overflow-tooltip></el-table-column>
            <el-table-column label="委托编号" align="left" prop="entrustNum" min-width="180" show-overflow-tooltip></el-table-column>
            <el-table-column label="层数/高度/长度" align="left" prop="eleFloorNumber" min-width="120" show-overflow-tooltip></el-table-column>
            <el-table-column label="使用单位" align="left" prop="useUntName" min-width="150" show-overflow-tooltip></el-table-column>
            <el-table-column label="小区名称" align="left" prop="houseName" min-width="150" show-overflow-tooltip></el-table-column>
            <el-table-column label="到检年月" align="left" prop="inspectionMonth" min-width="120" show-overflow-tooltip></el-table-column>
            <el-table-column label="客户名称" align="left" prop="compName" min-width="150" show-overflow-tooltip></el-table-column> 
            <el-table-column label="其他检测费" align="left" prop="discTestOtherFee" min-width="110" show-overflow-tooltip>
              <template slot-scope="scope">
                {{ formatAmount(scope.row.discTestOtherFee) }}
              </template>
            </el-table-column>
            <el-table-column label="原价" align="left" prop="testCharge" min-width="100" show-overflow-tooltip>
              <template slot-scope="scope">
                {{ formatAmount(scope.row.testCharge) }}
              </template>
            </el-table-column>
            <el-table-column label="折扣" align="left" prop="custDiscount" min-width="80" show-overflow-tooltip></el-table-column>
            <el-table-column label="折扣价" align="left" prop="finalPrice" min-width="100" show-overflow-tooltip>
              <template slot-scope="scope">
                {{ formatAmount(scope.row.finalPrice) }}
              </template>
            </el-table-column>
            <el-table-column label="检测时间" align="left" prop="testEmployeeDate" min-width="120" show-overflow-tooltip :formatter="$tableDateFormatter"></el-table-column>
            <el-table-column label="检测员" align="left" prop="employeeName" min-width="100" show-overflow-tooltip></el-table-column>
            <el-table-column label="状态" align="left" prop="enabledState" min-width="90" show-overflow-tooltip :formatter="formatEnabledStateColumn"></el-table-column>
            <el-table-column label="创建时间" align="left" prop="createTime" min-width="160" show-overflow-tooltip :formatter="$tableDateFormatter"></el-table-column>
            <el-table-column label="创建人" align="left" prop="createBy" min-width="100" show-overflow-tooltip></el-table-column>
            <el-table-column label="台数" align="left" prop="eqpCount" min-width="100" show-overflow-tooltip></el-table-column>
            <el-table-column label="备注" align="left" prop="remark" min-width="120" show-overflow-tooltip></el-table-column>
            <el-table-column label="操作" align="left" prop="operation" min-width="100" show-overflow-tooltip fixed="right">
              <template slot-scope="scope">
                <PermissionMethodRow :disabledButtons="getDisabledButtons(scope.row)" :url="url" :id="'rowtoolbar'" @handleEdit="handleEdit(scope.row)" />
              </template>
            </el-table-column>
          </el-table>

          <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="queryParams.currPage" :page-sizes="[10, 20, 50, 100, 200, 500, 1000]"
                         :page-size="queryParams.pageSize" layout="total, sizes, prev, pager, next, jumper" :total="total" style="margin-top: 20px; text-align: right">
          </el-pagination>
        </el-form>
      </el-col>
    </el-row>

    <OtherExpenseDialog ref="otherExpenseDialog" @refresh="getList" />
  </div>
</template>

<script>
import { queryOtherFeeList, deleteOtherFee, exportOtherFee } from '@/api/contract/contract'
import OtherExpenseDialog from './OtherExpenseDialog.vue'
import PermissionMethodToolbar from '@/components/button/PermissionMethodToolbar.vue'
import PermissionMethodRow from '@/components/button/PermissionMethodRow.vue'

export default {
  name: 'OtherExpenseManagement',
  props: {
    url: {
      type: String,
      default: ''
    }
  },
  components: {
    OtherExpenseDialog,
    PermissionMethodToolbar,
    PermissionMethodRow
  },
  data () {
    return {
      showSearch: true,
      tableData: [],
      loading: false,
      total: 0,
      queryParams: {
        currPage: 1,
        pageSize: 200,
        compNames: '',
        useUntName: '',
        oidNo: '',
        houseName: '',
        inspectionMonthList: [],
        testDateRange: [],
        enabledState: '9'
      },
      selectedRows: []
    }
  },
  created () {
    this.getList()
  },
  methods: {
    getDisabledButtons (row) {
      let disabledButtons = []
      if (row.enabledState === '9') {
        disabledButtons.push('handleEdit')
      }
      return disabledButtons
    },
    formatAmount (val) {
      if (val === undefined || val === null || val === '') return ''
      const n = Number(val)
      if (Number.isNaN(n) || n === 0) return ''
      return n
    },
    formatEnabledStateColumn (row, column, cellValue) {
      const v = cellValue !== undefined && cellValue !== null ? String(cellValue) : ''
      const map = { '0': '已录入', '1': '停用', '9': '未录入' }
      return map[v] || v || '-'
    },
    handleQuery () {
      this.queryParams.currPage = 1
      this.getList()
    },
    handleSizeChange (val) {
      this.queryParams.pageSize = val
      this.queryParams.currPage = 1
      this.getList()
    },
    handleCurrentChange (val) {
      this.queryParams.currPage = val
      this.getList()
    },
    buildListParams () {
      const params = {
        currPage: this.queryParams.currPage,
        pageSize: this.queryParams.pageSize
      }
      if (this.queryParams.compNames) {
        params.compNames = this.queryParams.compNames
      }
      if (this.queryParams.useUntName) {
        params.useUntName = this.queryParams.useUntName
      }
      if (this.queryParams.oidNo) {
        params.oidNo = this.queryParams.oidNo
      }
      if (this.queryParams.testDateRange && this.queryParams.testDateRange.length === 2) {
        params.testDateRange = this.queryParams.testDateRange
      }
      if (this.queryParams.enabledState) {
        params.enabledState = this.queryParams.enabledState
      }
      if (this.queryParams.houseName) {
        params.houseName = this.queryParams.houseName
      }
      if (this.queryParams.inspectionMonthList) {
        params.inspectionMonthList = this.queryParams.inspectionMonthList
      }
      return params
    },
    getList () {
      this.loading = true
      const params = this.buildListParams()
      queryOtherFeeList(params)
        .then(res => {
          if (res.retCode === 'ok') {
            this.tableData = res.additionalData.records || res.additionalData.list || []
            this.total = res.additionalData.total || 0
          } else {
            this.$message.error(res.retMsg || '查询失败')
          }
          this.loading = false
        })
        .catch(error => {
          console.error('查询失败:', error)
          this.$message.error('查询失败')
          this.loading = false
        })
    },
    handleSelectionChange (selection) {
      this.selectedRows = selection
    },
    isNotEnteredRow (row) {
      return String(row.enabledState) === '9'
    },
    handleBatchSave () {
      if (this.selectedRows.length === 0) {
        this.$message.warning('请至少选择一条数据')
        return
      }
      const entered = this.selectedRows.filter(row => !this.isNotEnteredRow(row))
      if (entered.length > 0) {
        const oidNos = entered.map(row => row.oidNo).join(', ')
        this.$message.warning(`以下记录非未录入状态，不能批量录入：${oidNos}`)
        return
      }
      this.$refs.otherExpenseDialog.openDialog(this.selectedRows, 'batch')
    },
    handleEdit (row) {
      this.$refs.otherExpenseDialog.openDialog([row], 'edit')
    },
    handleDelete () {
      if (this.selectedRows.length === 0) {
        this.$message.warning('请至少选择一条数据')
        return
      }
      const ids = this.selectedRows
        .map(row => row.id || row.feeId)
        .filter(Boolean)
      if (ids.length === 0) {
        this.$message.warning('未录入状态无法删除')
        return
      }
      if (ids.length < this.selectedRows.length) {
        this.$message.warning('部分未录入状态无法删除，请重新选择')
        return
      }
      this.$confirm(`确定删除选中的 ${ids.length} 条记录吗？`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        deleteOtherFee(ids)
          .then(res => {
            if (res.retCode === 'ok') {
              this.$message.success(res.retMsg || '删除成功')
              this.getList()
            } else {
              this.$message.error(res.retMsg || '删除失败')
            }
          })
          .catch(error => {
            console.error('删除失败:', error)
            this.$message.error('删除失败')
          })
      }).catch(() => { })
    },
    exportToExcel () {
      this.$message.success('正在导出其他检测费用数据...')
      const params = this.buildListParams()
      exportOtherFee(params)
        .then(response => {
          const blob = new Blob([response], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
          const url = window.URL.createObjectURL(blob)
          const link = document.createElement('a')
          link.href = url
          link.download = '其他检测费用管理.xlsx'
          link.style.display = 'none'
          document.body.appendChild(link)
          link.click()
          document.body.removeChild(link)
          window.URL.revokeObjectURL(url)
          this.$message.success('导出成功')
        })
        .catch(error => {
          console.error('导出失败:', error)
          this.$message.error('导出失败：' + (error.message || '未知错误'))
        })
    }
  }
}
</script>

<style scoped>
.app-container {
  padding: 20px;
}
::v-deep .el-table__body-wrapper {
  z-index: 2;
}
</style>
